/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CdsServizio } from "./CdsServizio";
import { CdsSoggetto } from "./CdsSoggetto";
import { PaStazionePa } from "./PaStazionePa";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const CdsSoggettoServizioR = t.interface({});

// optional attributes
const CdsSoggettoServizioO = t.partial({
  commissione: t.boolean,

  dataFineValidita: UTCISODateFromString,

  dataInizioValidita: UTCISODateFromString,

  descrizioneServizio: t.string,

  fkCdsServizio: t.string,

  fkCdsSoggetto: t.string,

  fkStazione: t.string,

  id: t.Integer,

  idSoggettoServizio: t.string,

  servizio: CdsServizio,

  soggetto: CdsSoggetto,

  stazionePa: PaStazionePa
});

export const CdsSoggettoServizio = t.intersection(
  [CdsSoggettoServizioR, CdsSoggettoServizioO],
  "CdsSoggettoServizio"
);

export type CdsSoggettoServizio = t.TypeOf<typeof CdsSoggettoServizio>;
